/** The Settings page tabs, URL-synced as `?tab=` (General has no parameter, T-137). */
export const SETTINGS_TABS = ['general', 'sign-in'] as const;
export type SettingsTab = (typeof SETTINGS_TABS)[number];
